export default {
    ACAMADO: 1,
    CADEIRANTE: 2,
    CONVENCIONAL: 3,
    OUTROS: 4,
}